import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IUsersState, usersTypes } from './types';
import * as usersActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IUsersState = {
  users: [],
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IUsersState, action: UnsafeReturnType<T>): IUsersState;
}

const getUsers: IActionHandler<typeof usersActions['getUsers']> = (state, { payload }) => ({
  ...state,
});

const getUserById: IActionHandler<typeof usersActions['getUserById']> = (state, { payload }) => ({
  ...state,
});

const createUser: IActionHandler<typeof usersActions['createUser']> = (state, { payload }) => ({
  ...state,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [usersTypes.GET_USERS]: getUsers,
  [usersTypes.GET_USER_BY_ID]: getUserById,
  [usersTypes.CREATE_USER]: createUser,
};

const usersReducer = createReducer<IUsersState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { usersReducer, usersTypes, usersActions };
